module.exports = new __parcel__URL__("execute.d90a7dfa.png").toString();